<!--
 * @description: 商品详情 tab
 * @Author: Jay
 * @Date: 2021-09-25 15:03:22
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-15 10:34:44
-->
<template>
  <div>
    <div v-class="'animate__animated animate__fadeInUp'">
      <!-- 轮播图 -->
      <swiper class="swiper-top" :options="swiperOption">
        <swiper-slide
          class="swiper-item"
          v-for="(slide, index) in goodsList"
          :key="index"
        >
          <!-- 图片 -->
          <img
            class="item-img"
            :src="$api + slide.images"
            alt="fit"
            @click="pitchOn(index)"
          />
          <!-- 标题 -->
          <!-- <div
            class="font_size_df padding-top-xs text-cut text-black text-align"
            @click="pitchOn(index)"
          >
            {{ slide.goods_name }}
          </div> -->
        </swiper-slide>
        <!-- 左右切换 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
//页面引入swiper
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "goodsDetaTab",
  props: ["goodsList"],
  data() {
    return {
      //轮播图 配置
      swiperOption: {
        slidesPerView: 4,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        //间隔
        spaceBetween: 30,
        //每次滑动滚动的数量
        slidesPerGroup: 1,
        //循环播放
        // loop: true,
        //自动轮播
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        //左右标签
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    //选中
    pitchOn(index) {
      //   console.log(index);
      // 触发vuex事件 selectTap，将数据存放到store里去
      this.$store.commit("selectTap", {
        id: index,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//轮播图
.swiper-top {
  //   position: absolute;
  //   left: -40px;
  //   background-color: antiquewhite;
  .swiper-item {
    width: 202px;
    height: 302px;
    background-color: rgb(250, 171, 171);
    //轮播图 图片
    .item-img {
      width: 100%;
      height: 100%;
      // height: 190px;
      object-fit: fill;
      // object-fit: cover;
    }
  }
}
</style>